import React from 'react'

import s from './ControlLabel.module.scss'

interface Props {
  labelContent: React.ReactNode | React.ReactNode[]
  className?: string
  htmlFor?: string
}

export const ControlLabel = (props: Props) => {
  const { labelContent, className, htmlFor } = props
  return (
    <label className={`${s.label} ${className}`} htmlFor={htmlFor}>
      {labelContent}
    </label>
  )
}
